import React from "react";

const PartnerTerms = () => {
  return (
    <div
      style={{
        padding: "40px",
        
        margin: "auto",
        fontFamily: "Arial, sans-serif",
        lineHeight: "1.6",
        color: "#333",
      }}
    >
     

      <h1 style={{  fontSize: "32px", margin: "60px 0 30px" }}>
        Privacy Policy for Partner Accounts
      </h1>

      <h2 style={{ fontSize: "24px", marginTop: "30px" }}>1. Data Collection</h2>
      <ul>
        <li>We collect personal and business information during signup, including:</li>
        <ul>
          <li>Owner/manager name, CNIC</li>
          <li>Contact details</li>
          <li>Property documents and photos</li>
          <li>Bank information for payouts</li>
        </ul>
      </ul>

      <h2 style={{ fontSize: "24px", marginTop: "30px" }}>2. Use of Data</h2>
      <ul>
        <li>Your data is used for:</li>
        <ul>
          <li>Identity verification</li>
          <li>Legal compliance</li>
          <li>Payment processing</li>
          <li>Quality control and auditing</li>
        </ul>
      </ul>

      <h2 style={{ fontSize: "24px", marginTop: "30px" }}>3. Data Sharing</h2>
      <ul>
        <li>We do not share your personal data with third parties, except:</li>
        <ul>
          <li>When required by law</li>
          <li>For government/tourism authority compliance</li>
          <li>With your written consent for collaborations or promotions</li>
        </ul>
      </ul>

      <h2 style={{ fontSize: "24px", marginTop: "30px" }}>4. Data Security</h2>
      <ul>
        <li>All your data is stored on secure servers with restricted access.</li>
        <li>Staff handling your data are trained in confidentiality protocols.</li>
      </ul>

      <h2 style={{ fontSize: "24px", marginTop: "30px" }}>5. Account Security</h2>
      <ul>
        <li>
          You are responsible for maintaining the confidentiality of your partner account. Notify us immediately in
          case of:
        </li>
        <ul>
          <li>Unauthorized access</li>
          <li>Suspicious activity</li>
          <li>Breach of terms by your own staff</li>
        </ul>
      </ul>

      <h2 style={{ fontSize: "24px", marginTop: "30px" }}>6. Policy Updates</h2>
      <ul>
        <li>Yovho may update these policies at any time. All changes will be:</li>
        <ul>
          <li>Shared via email and dashboard notification</li>
          <li>Considered accepted if the account continues to operate after notification</li>
        </ul>
      </ul>

      <p style={{ marginTop: "40px", fontWeight: "bold" }}>
        By registering as a Yovho Partner, you agree to these Terms and the Privacy Policy.
      </p>

      <p>
        <strong>Need help or have questions?</strong> <br />
        Reach out to our team at{" "}
        <a href="mailto:partner@yovho.com" style={{ color: "#007bff" }}>
          partner@yovho.com
        </a>{" "}
        or visit our Yovho office for support.
      </p>
    </div>
  );
};

export default PartnerTerms;
